export default "__VITE_ASSET__3yDy4ArJ__"